import { Radio, Sparkles } from "lucide-react";
import { useBroadcast } from "@/context/BroadcastContext";

const INVENTORY = {
  sponsor: [
    { title: "Durante el programa", text: "Naming o co-branding integrado en los seis actos del episodio.", icon: Radio },
    { title: "Durante comerciales", text: "Dinámica de regreso, recompensa y presencia de sponsor en la segunda pantalla.", icon: Sparkles },
  ],
  brand: [
    { title: "Durante el programa", text: "Product placement en uno, dos o seis actos, según el nivel contratado.", icon: Radio },
    { title: "Durante comerciales", text: "Trivia, reto o recompensa de producto activable desde la segunda pantalla.", icon: Sparkles },
  ],
};

export const CommercialInventory = ({ audience }) => {
  const { state } = useBroadcast();
  const isCommercial = state.mode === "commercials";
  return (
    <section data-testid={`commercial-inventory-${audience}`} className="border-y border-ink/10 py-10">
      <div className="flex flex-wrap items-end justify-between gap-5"><div><p className="font-mono text-[10px] uppercase tracking-widest text-coral">Inventario de doble pantalla</p><h2 className="mt-3 font-display text-3xl font-extrabold text-ink">Doble pantalla. Cuádruple impacto.</h2></div><span data-testid={`commercial-inventory-status-${audience}`} className={`rounded-full px-3 py-2 font-mono text-[10px] uppercase tracking-widest ${isCommercial ? "bg-gold/35 text-ink" : "bg-mint/40 text-ink"}`}>{isCommercial ? "Comerciales activos" : "Programa al aire"}</span></div>
      <div className="mt-7 grid gap-4 md:grid-cols-2">{INVENTORY[audience].map(({ title, text, icon: Icon }) => <article key={title} className="bg-white p-6 shadow-[0_8px_30px_rgb(0,0,0,0.04)]"><Icon className="h-5 w-5 text-coral" aria-hidden="true" /><h3 className="mt-4 font-display text-xl font-bold text-ink">{title}</h3><p className="mt-2 text-sm leading-relaxed text-ink/65">{text}</p></article>)}</div>
    </section>
  );
};